import React from 'react';

export const setProfileData = (data) => {
  localStorage.setItem("hostOnBoarding", JSON.stringify(data));
};

export const getProfileData = () => JSON.parse(localStorage.getItem("hostOnBoarding"))
